/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderItemTransferDto
 */
export interface OrderItemTransferDto {
    /**
     * 
     * @type {number}
     * @memberof OrderItemTransferDto
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemTransferDto
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemTransferDto
     */
    unitPrice: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemTransferDto
     */
    fromOrderId: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemTransferDto
     */
    fromOrderNumber: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemTransferDto
     */
    toOrderId: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemTransferDto
     */
    toOrderNumber: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemTransferDto
     */
    productId: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemTransferDto
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemTransferDto
     */
    note?: string;
    /**
     * 
     * @type {Date}
     * @memberof OrderItemTransferDto
     */
    transferredAt: Date;
}

/**
 * Check if a given object implements the OrderItemTransferDto interface.
 */
export function instanceOfOrderItemTransferDto(value: object): value is OrderItemTransferDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('unitPrice' in value) || value['unitPrice'] === undefined) return false;
    if (!('fromOrderId' in value) || value['fromOrderId'] === undefined) return false;
    if (!('fromOrderNumber' in value) || value['fromOrderNumber'] === undefined) return false;
    if (!('toOrderId' in value) || value['toOrderId'] === undefined) return false;
    if (!('toOrderNumber' in value) || value['toOrderNumber'] === undefined) return false;
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('productName' in value) || value['productName'] === undefined) return false;
    if (!('transferredAt' in value) || value['transferredAt'] === undefined) return false;
    return true;
}

export function OrderItemTransferDtoFromJSON(json: any): OrderItemTransferDto {
    return OrderItemTransferDtoFromJSONTyped(json, false);
}

export function OrderItemTransferDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderItemTransferDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'quantity': json['quantity'],
        'unitPrice': json['unitPrice'],
        'fromOrderId': json['fromOrderId'],
        'fromOrderNumber': json['fromOrderNumber'],
        'toOrderId': json['toOrderId'],
        'toOrderNumber': json['toOrderNumber'],
        'productId': json['productId'],
        'productName': json['productName'],
        'note': json['note'] == null ? undefined : json['note'],
        'transferredAt': (new Date(json['transferredAt'])),
    };
}

export function OrderItemTransferDtoToJSON(value?: OrderItemTransferDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'quantity': value['quantity'],
        'unitPrice': value['unitPrice'],
        'fromOrderId': value['fromOrderId'],
        'fromOrderNumber': value['fromOrderNumber'],
        'toOrderId': value['toOrderId'],
        'toOrderNumber': value['toOrderNumber'],
        'productId': value['productId'],
        'productName': value['productName'],
        'note': value['note'],
        'transferredAt': ((value['transferredAt']).toISOString()),
    };
}

